import { render, staticRenderFns } from "./ActionSolicitarPartes.vue?vue&type=template&id=00b0561d&scoped=true&lang=pug"
import script from "./ActionSolicitarPartes.vue?vue&type=script&lang=js"
export * from "./ActionSolicitarPartes.vue?vue&type=script&lang=js"
import style0 from "./ActionSolicitarPartes.vue?vue&type=style&index=0&id=00b0561d&prod&lang=scss"
import style1 from "./ActionSolicitarPartes.vue?vue&type=style&index=1&id=00b0561d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b0561d",
  null
  
)

export default component.exports